import { STORAGE_KEY } from '@/constant/constant';
import { deleteDOM, noOpenModal } from '@/service/api';
import { canShowAnyPop } from '@/service/strategy/priority';
import { getLocal } from '@/utils/storage';
import { popupFlowLog } from '@/utils/popupFlowDebug';

const timeWillShow = (time, conditionDuration) => {
  const nowTime = new Date().getTime();
  const timer = nowTime - time - conditionDuration * 1000;
  if (timer >= 0) {
    return true;
  } else {
    return false;
  }
};

const scrollWillShow = (settings) => {
  var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
  var innerHeight = window.innerHeight;
  var scrollHeight = document.body.scrollHeight;
  if (settings?.rules?.loadingPageSlideType === 'Percentage') {
    var percent = parseInt(((scrollTop + innerHeight) / scrollHeight) * 100 + '');
    if (percent >= settings?.rules.loadingPageSlide) {
      return true;
    }
  } else if (settings?.rules?.loadingPageSlideType == 'Pixel') {
    if (scrollTop >= settings?.rules?.loadingPageSlidePixel) {
      return true;
    }
  }
  return false;
};

const scrollListen = () => {
  setTimeout(() => {
    popShow.matchedConditions();
  }, 0);
};

class PopShow {
  /**
   * 原始列表
   */
  originList: any[];

  /**
   * 等待触发列表
   */
  waitTriggerList: any[];

  /**
   * 等待显示列表
   */
  waitShowList: any[];

  /**
   * 时间监听器
   */
  timeListener: any | undefined;

  /**
   * 显示回调
   */
  callback: any | undefined;

  /**
   * 加载开始时间
   */
  loadStartTime: number | undefined;

  /**
   * 滚动位置
   */
  scrollTop: number | undefined;

  /**
   * 是否可以显示弹窗
   */
  canshowPop: boolean | undefined;

  /**
   * 配置
   */
  config: any | undefined;

  /**
   * 本次多订阅展示链路的触发选项（如 leaveBeta），用于与倒计时/下滑条件做 OR 补充
   */
  triggerOptions: any | undefined;

  constructor() {
    this.originList = [];
    this.waitTriggerList = [];
    this.waitShowList = [];
    this.timeListener = null;
    this.callback = undefined;
    this.loadStartTime = undefined;
    this.scrollTop = undefined;
    this.canshowPop = false;
    this.config = undefined;
    this.triggerOptions = undefined;
  }

  showTriggers(list, callback, loadStartTime, config, triggerOptions?: any) {
    this.canshowPop = true;
    this.config = JSON.parse(JSON.stringify(config || {}));
    this.triggerOptions = triggerOptions || {};
    // console.log('触发0的弹窗显示逻辑', list);
    // 存储显示回调
    if (callback && typeof callback === 'function') {
      this.callback = callback;
    }
    this.loadStartTime = loadStartTime;
    // 处理列表
    this.originList = list;
    // console.log('判断符合条件的弹窗');
    this.matchShowConditions(list);
    popupFlowLog(
      'show.showTriggers trigger=%s originCount=%d waitShow=%d waitTrigger=%d willAddListener=%s',
      this.triggerOptions?.trigger ?? '',
      list?.length ?? 0,
      this.waitShowList.length,
      this.waitTriggerList.length,
      this.waitTriggerList.length > 0
    );
    if (this.waitTriggerList.length > 0) {
      // console.log('有监听项需要监听');
      this.addShowConditionListener();
    }
    if (this.waitShowList.length > 0 && this.canshowPop) {
      // console.log('有显示项需要显示');
      this.showPop();
    } else if (this.waitShowList.length === 0 && this.waitTriggerList.length > 0) {
      popupFlowLog(
        'show.showTriggers waiting only (countdown/slide/listener) trigger=%s waitTriggerIds=%o',
        this.triggerOptions?.trigger ?? '',
        this.waitTriggerList.map((p: any) => p?.id)
      );
    } else if (this.waitShowList.length === 0 && this.waitTriggerList.length === 0) {
      popupFlowLog(
        'show.showTriggers nothing to show and nothing to listen trigger=%s originIds=%o',
        this.triggerOptions?.trigger ?? '',
        list?.map((p: any) => p?.id)
      );
    }
  }

  matchShowConditions(list) {
    // 匹配条件
    const willShow = [];
    const waitTrigger = [];
    for (let i = 0; i < list.length; i++) {
      const popConfig = list[i];
      if (!popConfig) {
        continue;
      }
      if (popConfig.type === 'POP_WINDOW') {
        // 弹窗
        const rules = popConfig.settings?.rules;
        // 离开意图已由外部 mouseleave 满足后再 load；此处必须立即进入展示队列，否则会既不进 willShow 也不进 waitTrigger（原逻辑只认倒计时/下滑）
        if (this.triggerOptions?.trigger === 'leaveBeta' && rules?.readyToLeaveBate) {
          willShow.push(popConfig);
        } else if (rules?.loadingCountDownShow) {
          // 判断时间
          const show = timeWillShow(this.loadStartTime, rules.loadingCountDown);
          if (show) {
            willShow.push(popConfig);
          } else {
            waitTrigger.push(popConfig);
          }
        } else if (rules?.loadingPageSlideShow) {
          // 判断下滑
          const show = scrollWillShow(popConfig.settings);
          if (show) {
            willShow.push(popConfig);
          } else {
            waitTrigger.push(popConfig);
          }
        }
      } else if (popConfig.type === 'WheelOfFortune') {
        // 转盘
        // 判断倒计时
        const show = timeWillShow(this.loadStartTime, popConfig.settings?.timing.afterSeconds);
        if (show) {
          willShow.push(popConfig);
        } else {
          waitTrigger.push(popConfig);
        }
      }
    }
    this.waitShowList = willShow;
    this.waitTriggerList = waitTrigger;
    popupFlowLog(
      'show.matchShowConditions trigger=%s willShowIds=%o waitTriggerIds=%o',
      this.triggerOptions?.trigger ?? '',
      willShow.map((p: any) => p?.id),
      waitTrigger.map((p: any) => p?.id)
    );
    // console.log('初始化完成', this.waitShowList, this.waitTriggerList);
  }

  timeListen() {
    // 匹配条件
    const list = [].concat(this.waitTriggerList);
    const willShow = [];
    const waitTrigger = [];
    for (let i = 0; i < list.length; i++) {
      const popConfig = list[i];
      if (!popConfig) {
        continue;
      }
      if (popConfig.type === 'POP_WINDOW') {
        // 弹窗
        const rules = popConfig.settings?.rules;
        if (this.triggerOptions?.trigger === 'leaveBeta' && rules?.readyToLeaveBate) {
          willShow.push(popConfig);
        } else if (rules?.loadingCountDownShow) {
          // 判断时间
          const show = timeWillShow(this.loadStartTime, rules.loadingCountDown);
          if (show) {
            willShow.push(popConfig);
          } else {
            waitTrigger.push(popConfig);
          }
        }
      } else if (popConfig.type === 'WheelOfFortune') {
        // 转盘
        // 判断倒计时
        const show = timeWillShow(this.loadStartTime, popConfig.settings?.timing.afterSeconds);
        if (show) {
          willShow.push(popConfig);
        } else {
          waitTrigger.push(popConfig);
        }
      }
    }
    this.waitShowList = this.waitShowList.concat(willShow);
    this.waitTriggerList = this.waitTriggerList.filter((item) => willShow.includes(item) === false);
    if (waitTrigger.length === 0) {
      clearInterval(this.timeListener);
    }

    // console.log('监听完成', this.waitShowList, this.waitTriggerList);
    if (this.waitShowList.length > 0 && this.canshowPop) {
      // console.log('有显示项需要显示');
      this.showPop();
    }
  }

  matchedConditions() {
    var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
    if (scrollTop - this.scrollTop >= 40) {
      this.scrollTop = scrollTop;
      const list = [].concat(this.waitTriggerList);
      const willShow = [];
      const waitTrigger = [];
      for (let i = 0; i < list.length; i++) {
        const popConfig = list[i];
        if (!popConfig) {
          continue;
        }
        if (popConfig.type === 'POP_WINDOW') {
          // 弹窗
          if (popConfig.settings?.rules.loadingPageSlideShow) {
            // 判断下滑
            const show = scrollWillShow(popConfig.settings);
            if (show) {
              willShow.push(popConfig);
            } else {
              waitTrigger.push(popConfig);
            }
          }
        }
      }
      this.waitShowList = this.waitShowList.concat(willShow);

      this.waitTriggerList = this.waitTriggerList.filter((item) => willShow.includes(item) === false);
      if (waitTrigger.length === 0) {
        window.removeEventListener('scroll', scrollListen);
      }
      // console.log('滚动完成', this.waitShowList, this.waitTriggerList);

      if (this.waitShowList.length > 0 && this.canshowPop) {
        // console.log('有显示项需要显示');
        this.showPop();
      }
    }
  }

  addShowConditionListener() {
    this.timeListener = setInterval(() => {
      // 判断所有条件
      this.timeListen();
    }, 500);

    this.scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
    window.addEventListener('scroll', scrollListen);
  }

  showPop() {
    if (!noOpenModal()) {
      popupFlowLog(
        'show.showPop blocked noOpenModal=false waitShow=%d waitTrigger=%d',
        this.waitShowList.length,
        this.waitTriggerList.length
      );
      this.canshowPop = false;
      // console.log('卡主了');
      return;
    }

    const popConfig = this.waitShowList.shift();
    // 判断全局上限、全局静默
    const canShow = canShowAnyPop(this.config);
    // console.log(`${canShow?'':'不'}符合全局上限、全局静默逻辑`);
    if (!popConfig) {
      popupFlowLog('show.showPop shift empty waitShow=%d canShow=%s', this.waitShowList.length, canShow);
    } else if (!canShow) {
      popupFlowLog('show.showPop blocked canShowAnyPop=false popId=%s', popConfig?.id);
    }
    if (popConfig && canShow) {
      // console.log('显示', !!this.callback, popConfig);
      const triggerPop = getLocal(STORAGE_KEY.TEMP_POP);
      if (triggerPop) {
        // const tempConfig = JSON.parse(triggerPop||'{}');
        // 有配置，不再管，因为悬浮窗和弹窗不是一个
        // if (`${popType}` === 0 || `${popType}` === 4) {
        //   console.log('同类型弹窗触发，如果是同一弹窗，静默或两次间隔过了；如果是不同弹窗，则优先级调了，以后优先级都会弹新的，清除悬浮框');
        //   // console.log('显示弹窗与触发icon一致，静默期和两次间隔已过，清除icon');
        //   localStorage?.removeItem(STORAGE_KEY.TEMP_POP);
        //   // 两次间隔过了，清除dom
        //   document?.querySelector('#cartx-icon')?.remove();
        //   deleteDOM('cartx-wrap');
        // }
        // 同一个弹窗触发的话，说明两次间隔过了，需要清除掉悬浮窗
        // if (popConfig.id === tempConfig.id) {
        // 0类型弹窗触发前清除icon逻辑
        // console.log('显示弹窗与触发icon一致，静默期和两次间隔已过，清除icon');
        // 同一个悬浮窗
        localStorage?.removeItem(STORAGE_KEY.TEMP_POP);
        // 两次间隔过了，清除dom
        document?.querySelector('#cartx-icon')?.remove();
        deleteDOM('cartx-wrap');
        // 清除加购弹窗
        deleteDOM('cartx-purchase-wrap');
        // }
      }
      this.canshowPop = false;
      popupFlowLog('show.showPop schedule getResponse popId=%s delayMs=250', popConfig?.id);
      setTimeout(() => {
        this.callback && this.callback(JSON.parse(JSON.stringify(popConfig)));
      }, 250);
    }
    this.clearAll(false, !canShow);
  }

  clearAll(force = false, onlyClearWaitShow = false) {
    if (force) {
      this.waitShowList = [];
      this.waitTriggerList = [];
    }
    if (onlyClearWaitShow) {
      this.waitShowList = [];
    }
    if (force || this.waitTriggerList.length === 0) {
      // console.log('停止监听');
      clearInterval(this.timeListener);
      window.removeEventListener('scroll', scrollListen);
    }
  }

  closeAnPop() {
    // console.log('弹窗关闭');
    setTimeout(() => {
      this.canshowPop = true;
      this.showPop();
    }, 10);
  }

  submitAnPop() {
    // console.log('弹窗提交');
    this.canshowPop = false;
    this.clearAll(true);
  }
}

const popShow = new PopShow();

const showFromTriggerList = (list, callback, loadStartTime, config, triggerOptions?: any) => {
  popShow.showTriggers(list, callback, loadStartTime, config, triggerOptions);
};

const closePopShowNext0 = () => {
  popShow.closeAnPop();
};

const submitPopClearAll0 = () => {
  popShow.submitAnPop();
};

const clearAll = (force = false, onlyClearWaitShow = false) => {
  popShow.clearAll(force, onlyClearWaitShow);
};

export { showFromTriggerList, closePopShowNext0, submitPopClearAll0, clearAll };
